import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LetDirective } from '@ngrx/component';
import { createSelector, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { selectIsB2bPriceVisibleOnSummaryPage, selectIsInStandaloneMode } from 'src/app/store/common/common.selectors';

import { FooterDisclaimerComponent } from './footer-disclaimer/footer-disclaimer.component';
import { FooterLinksComponent } from './footer-links/footer-links.component';

export const selectDisclaimerWhipeoutArray = createSelector(
  selectIsB2bPriceVisibleOnSummaryPage,
  isB2bPriceVisibleOnSummaryPage =>
    // if B2B price is not displayed (yet) we prevent / whipeout the summary disclaimer text.
    // => we only show this disclaimer text once the B2B price is visible to the user
    isB2bPriceVisibleOnSummaryPage ? [] : ['summary']
);

@Component({
  selector: 'cc-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, LetDirective, FooterDisclaimerComponent, FooterLinksComponent, AsyncPipe]
})

/**
 * Footer does contain
 * - disclaimer ("Weitere Informationen zum offiziellen Kraftstoffverbrauch...")
 * - links (black bottom bar with "Arbeiten bei Mercedes-Benz...")
 *
 * Footer always has to be shown, in standalone as well in integrated mode.
 * In integrated mode, the links will be provided by OneWeb, but disclaimer still needs to be displayed!
 */
export class FooterComponent {
  public readonly isInStandaloneMode$: Observable<boolean> = this.store.select(selectIsInStandaloneMode);

  public readonly disclaimerWhipeout$: Observable<string[]> = this.store.select(selectDisclaimerWhipeoutArray);

  public constructor(public readonly store: Store) {}
}
